// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBUTNueZV5GGHHO7Ua_poiENZxYJUYhg7M",
  authDomain: "developer-gp.firebaseapp.com",
  projectId: "developer-gp",
  storageBucket: "developer-gp.appspot.com",
  messagingSenderId: "301623644669",
  appId: "1:301623644669:web:9d20c318e875c3d563c994"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const  db = getFirestore(app);
export const storage =  getStorage(app)
export default app;